import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { McsisRole } from '@/models/constants/McsisRole';

@Component
export default class Terms extends Vue {
    public rolePharmacist: string = McsisRole[McsisRole.Pharmacist];
    public roleDoctor: string = McsisRole[McsisRole.Doctor];

    protected refuseTerms() {
        this.$emit('on-refuse');
    }

    protected acceptTerms() {
        this.$emit('on-accept');
    }
}
